<template>
  <div>
    <ul
      id="tabs-header"
      class="nav nav-pills"
    >
      <li class="nav-item">
        <button
          class="btn"
          :class="{ 'btn-danger': view === 'AnalyticsCommon', 'border-danger text-danger background-transparent': view !== 'AnalyticsCommon' }"
          @click="view = 'AnalyticsCommon'"
        >
          Аналитика ПС общая
        </button>
      </li>
      <li class="nav-item">
        <button
          class="btn"
          :class="{ 'btn-danger': view === 'AnalyticsYandex', 'border-danger text-danger background-transparent': view !== 'AnalyticsYandex' }"
          @click="view = 'AnalyticsYandex'"
        >
          Аналитика ПС Yandex
        </button>
      </li>
      <li class="nav-item">
        <button
          class="btn"
          :class="{ 'btn-danger': view === 'AnalyticsYandexUniqRes', 'border-danger text-danger background-transparent': view !== 'AnalyticsYandexUniqRes' }"
          @click="view = 'AnalyticsYandexUniqRes'"
        >
          Аналитика ПС Yandex: уникальные ресурсы
        </button>
      </li>
      <li class="nav-item">
        <button
          class="btn"
          :class="{ 'btn-danger': view === 'AnalyticsYandexTop10', 'border-danger text-danger background-transparent': view !== 'AnalyticsYandexTop10' }"
          @click="view = 'AnalyticsYandexTop10'"
        >
          Аналитика ПС Yandex: ТОП-10
        </button>
      </li>
    </ul>
    <div
      id="tabs-body"
      class="row"
    >
      <div class="col-md-12">
        <c-box
          :loading="loading"
        >
          <analytics-common
            v-if="view === 'AnalyticsCommon'"
            :data="report ? report.tonalityReport || [] : []"
            :loading="loading"
          />
          <analytics-yandex
            v-if="view === 'AnalyticsYandex'"
            :data="report ? report.searchEngineReport.YANDEX.phraseTops || {} : {}"
            :loading="loading"
          />
          <analytics-yandex-uniq-res
            v-if="view === 'AnalyticsYandexUniqRes'"
            :data="report ? report.searchEngineReport.YANDEX.tonalities || [] : []"
            :loading="loading"
          />
          <analytics-yandex-top10
            v-if="view === 'AnalyticsYandexTop10'"
            :data="report ? report.searchEngineReport.YANDEX.siteTop10 || [] : []"
            :loading="loading"
          />
        </c-box>
      </div>
    </div>
  </div>
</template>

<script>
import AnalyticsCommon from '../components/analytics/AnalyticsCommon'
import AnalyticsYandex from '../components/analytics/AnalyticsYandex'
import AnalyticsYandexUniqRes from '../components/analytics/AnalyticsYandexUniqRes'
import AnalyticsYandexTop10 from '../components/analytics/AnalyticsYandexTop10'
import CBox from '../../../../../../resources/js/components/ui/CBox'
import { mapState } from 'vuex'
import apiService from '../apiService'
import { Notification } from 'uiv'

export default {
  name: 'Analytics',
  components: { AnalyticsCommon, AnalyticsYandex, AnalyticsYandexUniqRes, AnalyticsYandexTop10, CBox },

  data: () => ({
    view: 'AnalyticsCommon',
    loading: true,
    report: undefined
  }),
  computed: {
    ...mapState({
      domainSelected: state => state.seo.client.domains.selected
    })
  },
  mounted () {
    if (this.domainSelected) {
      this.fetch()
    }
    this.$root.$on('clientDomainsSelectedChange', this.fetch)
  },
  methods: {
    fetch () {
      this.loading = true

      apiService.getAnalytics(this.domainSelected)
        .then(response => {
          this.report = response.data
        })
        .catch(() => {
          Notification.notify.error({
            title: 'Ошибка',
            content: 'Не удалось загрузить аналитику'
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
  #tabs-header .nav-item button {
    padding-left: 40px;
    padding-right: 40px;
    margin-right: 10px;
  }

  #tabs-header .nav-item button.btn-danger {
    background-color: #d71c3a;
  }

  #tabs-body {
    margin-top: 30px;
  }

  #tabs-body .box {
    overflow-x: auto;
  }
</style>
